export enum PublicApiNotificationTypeEnum {
  popup = 'popup',
  push = 'push',
}

export interface IOverrideKeyValue {
  key: string;
  value: string;
}

export interface ISendNotificationParams {
  endUsersIds?: string[];
  audiencesIds?: string[];
  environmentId: string;
  templateId: string;
  override: IOverrideKeyValue[];
  notificationType: PublicApiNotificationTypeEnum;
  title?: string;
  runtimeTitle?: string;
  message?: string;
  runtimeDescription?: string;
  startAt?: Date;
  endAt?: Date;
}
